import jQuery from 'jquery';
import '../../libs/select2/select2.min.js';

class ModuleSelect2{
    constructor(){
        function combineNodeLists(...nodeLists) {
            return Array.prototype.concat(...nodeLists.map(list => Array.from(list)));
        }
        const selects = combineNodeLists(
            document.querySelectorAll('.__select2__'),
            document.querySelectorAll('.gfield_select'),
        );

        selects.forEach((select) => {
            let placeholder = select.dataset.placeholder;
            let dropdownCssClass = select.dataset.cssclass;
            let search = select.dataset.search || -1;

            jQuery(select).select2({
                minimumResultsForSearch: search,
                maximumSelectionLength: 6,
                placeholder: placeholder,
                dir: "",
                // dropdownAutoWidth: true,
                dropdownCssClass: dropdownCssClass,
            });

            if (select.classList.contains('change-href')){
                jQuery(select).on('select2:select', ChangeValueSelect);
                select.addEventListener('change', ChangeValueSelect);

                function ChangeValueSelect(e){
                    const value = e.target.value;
                    if (value) {
                        window.location.href = value;
                    }
                }
            }
        })
    }
}

export default ModuleSelect2;